/**
 * @Author: hongwei
 * @Date: 2021-12-08 19:13:16.428
 * @Last Modified by: center
 * @Last Modified time: 2026-09-21 16:25:00
 */

const ICP_NUMBER_CN = '粤ICP备2020096351号-1';
const ICP_NUMBER_COM = '粤ICP备2020096351号-2';

export default {
    name: 'YqgFooter',

    computed: {
        icpNumber() {
            const host = this.$isServer
                ? (this.$ssrContext && this.$ssrContext.host) || ''
                : window.location.host;

            return /sjrtguarantee\.cn/.test(host) ? ICP_NUMBER_CN : ICP_NUMBER_COM;
        }
    }
};
